export const engagementAppGroupIdSurveyStats = "/engagement/:app_group_id/survey/stats";
